import axios from '@/http/axios'

export default {
  getAliToken: () => {
    return axios.get(`/ali/sts-token/`)
  }
}